module.exports = "https://bin.bnbstatic.com/_next/static/images/trust-wallet-028989d039f84aeeca202df339ce5d06.png";